import marqii from '@/assets/images/marqii.svg'
import { ConditionalComponent } from '@/components/ConditionalComponent/ConditionalComponent'
import { Flex } from '@/components/Flex'
import { IconButton } from '@/components/IconButton'
import { Image } from '@/components/Image'
import { ImpersonatingBanner } from '@/components/ImpersonatingBanner'
import { QuickNavigationButton } from '@/components/layouts/Header/QuickNavigationButton'
import { UpgradePackageButton } from '@/components/layouts/Header/UpgradePackageButton'
import { UserProfileDropdown } from '@/components/layouts/Header/UserProfileDropdown'
import { PaymentIssueWarningBanner } from '@/components/PaymentIssueWarningBanner/PaymentIssueWarningBanner'
import { Space } from '@/components/Space'
import { DashboardExperiments } from '@/experiments'
import { useIsMobile } from '@/hooks/useBreakpoint'
import { useFlag } from '@/hooks/useFlag'
import { PATHS } from '@/routes/PATHS'
import {
  usePremiumFeaturesHasUpgrade,
  usePremiumFeaturesStatus,
} from '@/stores/permissions/premiumFeatures'
import { Layout } from 'antd'
import { MenuIcon } from 'lucide-react'
import { Link } from 'react-router'
import { BeamerWidget } from './Beamer/BeamerWidget'
import styles from './styles.module.scss'

export const HEADER_TEST_ID = 'header-test-id'

export interface HeaderProps {
  onMenuClick?: () => void
  onQuickNavigationClick?: () => void
}

export function Header({ onMenuClick, onQuickNavigationClick }: HeaderProps) {
  const isMobile = useIsMobile()

  const shouldEnforceBillingFoundations = useFlag(
    DashboardExperiments.shouldEnforceBillingFoundations,
  )
  const showUpgradePackagePage = useFlag(DashboardExperiments.upgradePackagePage)

  const premiumFeaturesStatus = usePremiumFeaturesStatus()
  const hasUpgrade = usePremiumFeaturesHasUpgrade()

  const hasQuickNavigationFeature = useFlag(DashboardExperiments.quickNavigation)

  const shouldBlockAccount =
    premiumFeaturesStatus &&
    premiumFeaturesStatus === 'SUSPENDED' &&
    shouldEnforceBillingFoundations

  const shouldShowBeamer = !shouldBlockAccount

  return (
    <div>
      <ImpersonatingBanner />
      <PaymentIssueWarningBanner />

      <Layout.Header data-testid={HEADER_TEST_ID} className={styles.header}>
        <Flex align="center" gap="1rem">
          {isMobile && (
            <IconButton size="large" icon={<MenuIcon size={20} />} onClick={onMenuClick} />
          )}
          <Link to={PATHS.homePage}>
            <Space align="center">
              <Image src={marqii} width="100px" alt="Marqii logo" />
            </Space>
          </Link>
        </Flex>
        <Flex align="center" gap={isMobile ? 10 : 25}>
          <ConditionalComponent condition={hasUpgrade && showUpgradePackagePage}>
            <UpgradePackageButton />
          </ConditionalComponent>
          <ConditionalComponent condition={shouldShowBeamer}>
            <BeamerWidget />
          </ConditionalComponent>
          <ConditionalComponent condition={hasQuickNavigationFeature}>
            <QuickNavigationButton onClick={() => onQuickNavigationClick?.()} />
          </ConditionalComponent>
          <UserProfileDropdown />
        </Flex>
      </Layout.Header>
    </div>
  )
}
